import { Routes } from '@angular/router';
import { ACCOUNT_URLS, ACTIVATION_URLS, AUTH_URLS, ROUTE_URLS } from './app.routes.names';
import { authCanMatch, guestCanMatch } from './guards/auth.guard';
import { TokenGuard } from './guards/token.guard';

export const routes: Routes = [
  {
    path: '', loadComponent: () =>
       import('./voucher-topup/voucher-topup.component').then((m) => m.VoucherTopupComponent),
      canActivate: [TokenGuard]
  },
  {
    path: ROUTE_URLS.TOP_UP, loadComponent: () =>
      import('./landing-page/landing-page.component').then((m) => m.LandingPageComponent)
  },
   {
    path: ROUTE_URLS.VOUCHER, loadComponent: () =>
     import('./voucher-topup/voucher-topup.component').then((m) => m.VoucherTopupComponent)
  },
 {
    path: ROUTE_URLS.PORT, loadComponent: () =>
     import('./portin/portin.component').then((m) => m.PortinComponent)
  },
  {
    path: AUTH_URLS.BASE,
    canMatch: [guestCanMatch],
    loadChildren: () =>
      import('./authentication/authentication.module').then((m) => m.AuthenticationModule)
  },
  {
    path: ROUTE_URLS.SWAP_PLAN,
    loadComponent: () =>
      import('./swap-plan/swap-plan.component').then((m) => m.SwapPlanComponent)
  },
  {
    path: ACCOUNT_URLS.BASE,
    loadChildren: () =>
      import('./account/account.routes').then((m) => m.ACCOUNT_ROUTES)
  }
  
];
